import React from 'react';
import { Grid, Typography } from '@mui/material';

type Props = {
  label: string;
  value: React.ReactNode;
};

export const DetailRow = ({ label, value }: Props) => (
  <Grid container justifyContent="space-between" alignItems="center">
    <Typography variant="body2" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="body2">{value}</Typography>
  </Grid>
);
